export const GET_ADMIN_ASSISTANT_REQUEST = "GET_ADMIN_ASSISTANT_REQUEST";
export const GET_ADMIN_ASSISTANT_SUCCESS = "GET_ADMIN_ASSISTANT_SUCCESS";
export const GET_ADMIN_ASSISTANT_FAIL = "GET_ADMIN_ASSISTANT_FAIL";